export default "__VITE_ASSET__$kQrDVrd__"